export default __webpack_public_path__ + "static/dev-miami-6541d81e0236df445b1ad90a8abbc202.jpg";